import React from "react";
import { Statistic, Tooltip } from "antd";
import { OverviewCard } from "./OverviewCard";
import { KPICardProps, Variant, Severity } from "./types";

// Map Severity to Variant
const severityToVariant = (severity: Severity): Variant => {
  switch (severity) {
    case "critical":
      return "critical";
    case "warning":
      return "warning";
    case "info":
      return "default"; // Map info to default since there's no info variant
  }
};

export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  description,
  prefix,
  suffix,
  valueStyle,
  severity,
  variant,
  onClick,
  hoverable = false,
  children,
  className = "",
  duration,
}) => {
  // Use explicit variant if provided, otherwise map severity to variant, default to "default"
  const cardVariant: Variant =
    variant || (severity ? severityToVariant(severity) : "default");

  // Helper function to convert duration to tooltip text
  const getDurationTooltip = (dur: string): string => {
    if (dur === "24h") return "Last 24 hours";
    if (dur === "30d") return "Last 30 days";
    if (dur === "14d") return "Last 14 days";
    if (dur === "7d") return "Last 7 days";
    return dur;
  };

  return (
    <OverviewCard
      hoverable={hoverable || !!onClick}
      onClick={onClick}
      variant={cardVariant}
      className={`kpi-card ${className}`}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div style={{ flex: 1 }}>
          <Statistic
            title={title}
            value={value}
            prefix={prefix}
            suffix={suffix}
            valueStyle={valueStyle}
          />
        </div>
        {duration && (
          <Tooltip title={getDurationTooltip(duration)}>
            <span className="kpi-duration">{duration}</span>
          </Tooltip>
        )}
      </div>
      {description && <div className="kpi-description">{description}</div>}
      {children}
    </OverviewCard>
  );
};
